module.exports = __webpack_public_path__ + "img/doctor.7bb24f02.png";